<template>
  <div class="w-full pb-2 flex flex-col justify-start items-start gap-[15px]">
    <div class="w-full flex justify-start items-start gap-[11px]">
      <button
        v-if="hasPermission('Inventory_Reconcile_Stock_View')"
        :class="[
          'text-[14px] font-semibold leading-[20px] cursor-pointer focus:outline-none py-[5px]',
          {
            'border-b-2 border-[#2463EB] text-[#2463EB]':
              activeTabProp === 'pending',
            'text-[#96a0b5]': activeTabProp !== 'pending',
          },
        ]"
        @click="switchTab('pending')"
      >
        Pending Reconciliation
      </button>
      <button
        v-if="hasPermission('Inventory_Reconcile_Stock_View')"
        :class="[
          'text-[14px] font-semibold leading-[20px] cursor-pointer focus:outline-none py-[5px]',
          {
            'border-b-2 border-[#2463EB] text-[#2463EB]':
              activeTabProp === 'reconcile',
            'text-[#96a0b5]': activeTabProp !== 'reconcile',
          },
        ]"
        @click="switchTab('reconcile')"
      >
        Reconciled Stocks
      </button>
    </div>
    <div
      v-if="activeTabProp === 'pending'"
      class="flex xs:flex-col xl:flex-row xs:justify-start xl:justify-between w-full xs:items-start xs:gap-4 lg-gap-2 xl:items-center"
    >
      <p class="text-[#353535] text-[14px] leading-[20px] font-semibold">
        List of all storage areas
      </p>
      <div
        class="flex gap-1 sm:gap-3 flex-wrap xs:justify-start lg:justify-center xs:items-start lg:items-center"
      >
        <button
          @click="viewFilterPR"
          class="border-[1px] border-[#96a0b5] rounded-[8px] text-[#96a0b5] font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] flex items-center gap-[5px] outline-none focus:outline-none"
        >
          <span class="">
            <img src="/assets/icon/sort.svg" alt="" />
          </span>
          Filters
        </button>
        <!-- <button
          v-if="hasPermission('Inventory_Reconcile_Stock_Update')"
          class="border-[1px] bg-[#2463eb] rounded-[8px] text-white font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] outline-none focus:outline-none"
        >
          <span class="feather icon-plus text-white"></span> New Storage Area
        </button> -->
      </div>
    </div>
    <div
      v-if="activeTabProp === 'reconcile'"
      class="flex xs:flex-col xl:flex-row xs:justify-start xl:justify-between w-full xs:items-start xs:gap-4 lg-gap-2 xl:items-center"
    >
      <p class="text-[#353535] text-[14px] leading-[20px] font-semibold">
        List of all warehouses
      </p>
      <div
        class="flex gap-1 sm:gap-3 flex-wrap xs:justify-start lg:justify-center xs:items-start lg:items-center"
      >
        <button
          @click="viewFilter"
          class="border-[1px] border-[#96a0b5] rounded-[8px] text-[#96a0b5] font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] flex items-center gap-[5px] outline-none focus:outline-none"
        >
          <span class="">
            <img src="/assets/icon/sort.svg" alt="" />
          </span>
          Filters
        </button>
        <!-- <button
          v-if="hasPermission('Inventory_Reconcile_Stock_Update')"
          class="border-[1px] bg-[#2463eb] rounded-[8px] text-white font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] outline-none focus:outline-none"
        >
          <span class="feather icon-plus text-white"></span> New Warehouse
        </button> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["hasPermission", "activeTabProp", "viewFilterPR", "viewFilter"],
  methods: {
    switchTab(tab) {
      this.$emit("switchTab", tab);
    },
  },
};
</script>

<style></style>
